<template>
  <div class="news">
    <siteHeader />
    <div class="banner-carousel" v-if="bannerList.length > 0">
      <el-carousel height="400px">
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <div class="carousel-item" :style="`background-image: url(${item.url})`">
            <div class="carousel-content" v-if="item.description">
              <h3>{{ item.title }}</h3>
              <p>{{ item.description }}</p>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    
    <div class="content">
      <div class="container">
        <page-breadcrumb :paths="['学院风采', currentTab]" />
        
        <div class="page-content">
          <div class="left-nav">
            <h3>学院风采</h3>
            <ul>
              <li 
                v-for="tab in tabs" 
                :key="tab.name"
                :class="{ active: currentTab === tab.name }"
                @click="switchTab(tab.name)"
              >
                {{ tab.name }}
              </li>
            </ul>
          </div>

          <div class="right-content">
            <!-- <h2>{{ currentTab }}</h2> -->
            
            <!-- 静态图片展示，不带边框 -->
            <div class="static-image-container">
              <img :src="getCurrentImage" alt="" class="static-image">
            </div>
          </div>
        </div>
      </div>
    </div>
    <siteFooter />
  </div>
</template>

<script>
import PageBreadcrumb from '@/components/Breadcrumb.vue'
import siteHeader from '../components/SiteHeader.vue'
import siteFooter from '../components/SiteFooter.vue'
import { websiteApi } from '@/api'

export default {
  name: 'NewsPage',
  components: {
    'page-breadcrumb': PageBreadcrumb,
    siteHeader,
    siteFooter
  },
  data() {
    return {
      bannerList: [],
      currentTab: '员工风采',
      tabs: [
        { name: '员工风采', id: 33, image: require('@/assets/yuangongfengcai.jpg') },
        { name: '学员风采', id: 34, image: require('@/assets/xueyuanfengcai.jpg') },
        { name: '学院活动', id: 35, image: require('@/assets/xueyuanhuodong.jpg') }
      ]
    }
  },
  computed: {
    getCurrentImage() {
      const currentTab = this.tabs.find(tab => tab.name === this.currentTab);
      return currentTab ? currentTab.image : '';
    }
  },
  methods: {
    switchTab(tabName) {
      this.currentTab = tabName;
    },
    async getBanners() {
      try {
        const res = await websiteApi.getPictureList();
        if (res.code === 200) {
          // 筛选出 location 为 1 的轮播图数据
          this.bannerList = res.rows
            .filter(item => item.location === 1)
            .map((item) => ({
              id: item.id,
              url: item.carouselUrl,
              title: "",
              subtitle: "",
              description: item.remark || "",
            }));
        }
      } catch (error) {
        console.error("获取轮播图失败：", error);
      }
    }
  },
  async created() {
    await this.getBanners();
  }
}
</script>

<style scoped>
/* 静态图片样式 - 无边框和阴影 */
.static-image-container {
  width: 100%;
  text-align: center;
  margin-top: 20px;
}

.static-image {
  max-width: 100%;
  height: auto;
}

/* Banner轮播图样式 */
.banner-carousel {
  margin-bottom: 20px;
  width: 100%;
  overflow: hidden;
}

.carousel-item {
  height: 400px;
  background-size: cover;
  background-position: center;
  position: relative;
}

.carousel-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
}

/* 确保轮播区域占满全屏 */
:deep(.el-carousel__container) {
  width: 100vw;
}

:deep(.el-carousel__item) {
  width: 100vw !important;
}

.carousel-content h3 {
  margin: 0 0 10px 0;
  font-size: 24px;
}

.carousel-content p {
  margin: 0;
  font-size: 16px;
}

.content {
  padding: 20px 0 40px 0;
  min-height: calc(100vh - 60px);
  background: transparent;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.page-content {
  display: flex;
  gap: 30px;
  margin-top: 20px;
}

.left-nav {
  width: 200px;
  background: transparent;
  padding: 20px;
  border-radius: 4px;
  /* box-shadow: 0 2px 4px rgba(0,0,0,0.05); */
  position: sticky;
  top: 80px;
  align-self: flex-start;
  max-height: calc(100vh - 160px);
  overflow-y: auto;
  color: #dddddd;
}

.left-nav h3 {
  margin: 0 0 15px 0;
  padding-bottom: 10px;
  /* border-bottom: 2px solid #1e88e5; */
  color: #333;
}

.left-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.left-nav li {
  padding: 12px 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 4px;
}

.left-nav li:hover {
  background: #e3f2fd;
  /* color: #1e88e5; */
}

.left-nav li.active {
  /* background: #1e88e5; */
  color: #0b0b0b;
}

.right-content {
  flex: 1;
  background: transparent;
  padding: 30px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.right-content h2 {
  margin: 0 0 20px 0;
  color: #000000;
  padding-bottom: 10px;
  font-size: 12px;
  border: 1px solid #d8d8d8;
  display: inline-block;
  padding: 8px 15px;
  border-radius: 15px;
  background-color: #d8d8d8;
}

.news-item {
  display: flex;
  align-items: center;
  padding: 25px;
  border-bottom: 1px solid #eee;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.news-item:hover {
  background: #f8f9fa;
  transform: translateX(5px);
}

.news-item:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 4px;
  background: #1e88e5;
  opacity: 0;
  transition: opacity 0.3s;
}

.news-item:hover:before {
  opacity: 1;
}

.news-content {
  flex: 1;
}

.news-content h3 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 18px;
  transition: color 0.3s;
  display: flex;
  align-items: center;
}

.news-content h3.hovered {
  color: #1e88e5;
}

.new-tag {
  background: #ff4081;
  color: white;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 12px;
  margin-left: 10px;
}

.summary {
  color: #666;
  margin: 0 0 12px 0;
  line-height: 1.6;
}

.news-meta {
  display: flex;
  gap: 20px;
  color: #999;
  font-size: 14px;
}

.news-meta i {
  margin-right: 5px;
}

.news-more {
  display: flex;
  align-items: center;
  color: #999;
  transition: all 0.3s;
}

.news-more.hovered {
  color: #1e88e5;
}

.read-more {
  margin-right: 10px;
  opacity: 0;
  transform: translateX(20px);
  transition: all 0.3s;
}

.news-item:hover .read-more {
  opacity: 1;
  transform: translateX(0);
}

.arrow-right {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-top: 2px solid currentColor;
  border-right: 2px solid currentColor;
  transform: rotate(45deg);
  transition: transform 0.3s;
}

.news-item:hover .arrow-right {
  transform: rotate(45deg) scale(1.2);
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  gap: 20px;
}

.page-btn {
  padding: 8px 16px;
  border: 1px solid #1e88e5;
  background: white;
  color: #1e88e5;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.page-btn:hover:not(:disabled) {
  background: #1e88e5;
  color: white;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  color: #666;
}
</style> 